import type { CollectableItem } from "../collectableItem";
import { type TintConfig, type Tintable } from "../interfaces";
import { deserializeItem, deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { LootBox } from "./lootBox";
import { PowerPlantKeyCard } from "../items/powerPlantKeyCard";

export class PowerPlantKeyCardLootBox extends LootBox implements Tintable {
	static key = "PowerPlantKeyCardLootBox";

	constructor(xy: XY, loot: CollectableItem[] = [new PowerPlantKeyCard(1)]) {
		super(xy, loot);
	}

	getTint(): TintConfig | null {
		return { r: 255, g: 255, b: 255, minAlpha: 0.0, maxAlpha: 0.3 };
	}

	getAnimationSpeedMultiplier(): number {
		return 1.0;
	}

	static deserialize(data: any): PowerPlantKeyCardLootBox {
		const box = new PowerPlantKeyCardLootBox(deserializeXY(data.xy));
		box.visualId = data.visualId;
		if (data.loot) {
			box.loot = data.loot.map((d: any) => deserializeItem(d));
		}
		return box;
	}
}
